import * as TyreChangeOrderModels from '../../models/tyre-change-order/tyre-change-order';
import { TyreChangeOrderSearchModel } from '../../models/tyre-change-order/tyre-change-orderSearch';
import * as Models from '../../models/commonModels';

export class GetStatusDictionary {
  static readonly type = '[TyreChange] Get Status Dictionary';
  constructor() { }
}
export class GetList {
  static readonly type = '[TyreChange] List';
  constructor(public Search: TyreChangeOrderSearchModel) { }
}

export class SetSearch {
  static readonly type = '[TyreChange] Set Search';
  constructor(public Search: TyreChangeOrderSearchModel) { }
}

export class ResetSearch {
  static readonly type = '[TyreChange] Reset Search';
  constructor() { }
}

export class SetListPage {
  static readonly type = '[TyreChange] Set List Page';
  constructor(public Search: TyreChangeOrderSearchModel) { }
}

export class Insert {
  static readonly type = '[TyreChange] Insert';
  constructor(public Order: TyreChangeOrderModels.TyreChangeOrderModel, public Version: number) { }
}

export class DisposeSearch {
  static readonly type = '[TyreChange] DisposeSearch';
  constructor() { }
}

export class Set {
  static readonly type = '[TyreChange] Set';
  constructor(public Order: Models.Request<TyreChangeOrderModels.TyreChangeOrderModel>) { }
}

export class Get {
  static readonly type = '[TyreChange] Get';
  constructor(public OrderId: Models.RequestModel) { }
}
